import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicTextEditor from "./BasicTextEditor";

const TextEditorPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Text Editor"} description={""} />
      <Divider light />
      <BasicTextEditor />
    </Paper>
  );
};

export default TextEditorPage;
